module.exports = __webpack_public_path__ + "img/nobg.a59e8101.png";